import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabase';

const BUCKET = 'Monsters';

function MonstersList() {
  const [files, setFiles] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchFiles() {
      try {
        setError(null);
        console.log('[MonstersList] Fetching from bucket:', BUCKET);
        const { data, error: err } = await supabase.storage.from(BUCKET).list('', { limit: 500 });
        console.log('[MonstersList] Raw response:', { data, error: err, dataLength: data?.length, firstItem: data?.[0] });
        if (err) {
          console.error('[MonstersList] Storage error:', err);
          throw err;
        }
        const rawNames = (data || []).map((f) => f?.name).filter(Boolean);
        const names = (data || []).filter((f) => f.name && f.name.endsWith('.json')).map((f) => f.name);
        console.log('[MonstersList] Raw file names:', rawNames, '| JSON files:', names);
        setFiles(names);
      } catch (e) {
        console.error('[MonstersList] Caught error:', e);
        setError(e.message || 'Failed to load monsters');
        setFiles([]);
      } finally {
        setLoading(false);
      }
    }
    fetchFiles();
  }, []);

  const filtered = search.trim()
    ? files.filter((f) => f.toLowerCase().includes(search.toLowerCase()))
    : files;

  return (
    <section className="section">
      <div className="container">
        <h1 className="title">Monsters</h1>
        <p className="subtitle">Browse and manage monsters from storage</p>

        <div className="field has-addons mb-4">
          <div className="control is-expanded">
            <input
              className="input"
              type="text"
              placeholder="Search monsters..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="control">
            <Link to="/monsters/create" className="button is-primary">
              Create Monster (AI)
            </Link>
          </div>
        </div>

        {error && (
          <div className="notification is-warning">
            {error}
            <br />
            <small>Ensure the &quot;Monsters&quot; bucket exists and allows read access.</small>
          </div>
        )}

        {loading ? (
          <p>Loading...</p>
        ) : filtered.length === 0 ? (
          <div className="box has-text-centered" style={{ padding: '3rem' }}>
            <p className="mb-4">
              {search ? 'No monsters match your search.' : 'No monsters in storage yet.'}
            </p>
            {!search && (
              <Link to="/monsters/create" className="button is-primary is-large">
                Create one with AI
              </Link>
            )}
          </div>
        ) : (
          <div className="columns is-multiline">
            {filtered.map((name) => (
              <div key={name} className="column is-one-quarter">
                <Link to={`/monsters/${encodeURIComponent(name)}`} className="box">
                  {name.replace('.json', '')}
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default MonstersList;
